import { forwardRef } from 'react';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { Box, Dialog } from '@mui/material';
import { spinnerOverlayStyleBuilder } from './interstitialOverlayStyleBuilder';
import { idBuilder } from '../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export const InterstitialOverlay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    fullScreen,
    id,
    sx,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  return fullScreen ? /*#__PURE__*/_jsx(Dialog, {
    open: true,
    disableEscapeKeyDown: true,
    sx: {
      '.MuiBackdrop-root': {
        backgroundColor: 'rgba(74,74,74,0.8)'
      }
    },
    id: idBuilder('interstitial-overlay-fullscreen-root', id),
    "data-testid": idBuilder('interstitial-overlay-fullscreen-root', rest['data-testid']),
    children: /*#__PURE__*/_jsx(Box, {
      sx: spinnerOverlayStyleBuilder(theme, fullScreen),
      id: idBuilder('interstitial-overlay-fullscreen-root', id),
      "data-testid": idBuilder('interstitial-overlay-fullscreen-root', rest['data-testid']),
      children: children
    })
  }) : /*#__PURE__*/_jsx(Box, {
    sx: spinnerOverlayStyleBuilder(theme, fullScreen),
    id: idBuilder('interstitial-overlay-root', id),
    "data-testid": idBuilder('interstitial-overlay-root', rest['data-testid']),
    children: children
  });
});
InterstitialOverlay.displayName = 'InterstitialOverlay';